import { Controller } from "stimulus"

class AdTargetController extends Controller {
  initialize() {
    try {
      const targets = this.data.get('targets');
      if (targets) {
        const parsedTargets = JSON.parse(targets);
        Object.keys(parsedTargets).forEach(targetKey => {
          const targetValue = parsedTargets[targetKey];
          window.MConstants.adTargets[targetKey] = targetValue;
        })
      }
    } catch(e) {
      // failed to parse string, ignore error
    }
  }

}

export default AdTargetController;
